import * as React from 'react'
function SvgCopy(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24 12c1.2 0 2 .8 2 2v20c0 1.2-.8 2-2 2H8c-1.2 0-2-.8-2-2V14c0-1.2.8-2 2-2zm8-8c1.2 0 2 .8 2 2v24h-4V8H12V4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCopy
